import type { FavoritesPickerProps } from "./components/FavoritesPicker";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailFolderView" */ "./lazyIndex"), { name: "MailFolderView" });

export const FavoritesPicker: LazyComponent<FavoritesPickerProps, unknown, void> = createLazyComponent(lazyModule, m => m.FavoritesPicker);
